// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"projectSummary_sectionTitle__3Y8Z2","label":"projectSummary_label__1Whqe"};